const reduceTokens = (amount, userInfo, setUserInfo) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
    fetch(`${API_BASE_URL}/reduceTokens`,{
      method:'POST',
      headers:{
        'Content-Type': 'application/json',
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
    },
      body:JSON.stringify({
        amount:amount,
        userInfo:userInfo,
      })
    })
    .then(res=>{
      return res.json();
    })
    .then(data=>{
      const tempUserInfo = {...userInfo}
      tempUserInfo.tokens = data.user.tokens
      setUserInfo(tempUserInfo)
    })
}
export default reduceTokens